import { Page } from './Page';

export class PrintableDashboard {
    pages: Page[];

    constructor() { this.pages = []; }
}